import React from "react";
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { candidate, social, contactInfo, nav } from "../mock";
import VisitCounter from "./VisitCounter";

const ICONS = { Facebook, Instagram, Youtube };

const Footer = () => {
  return (
    <footer className="bg-campaign-cream border-t-4 border-campaign-ink pt-14 pb-8 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="font-display text-2xl bg-campaign-blue text-campaign-yellow px-2 py-1 -rotate-2">KURÁŇ</span>
            <span className="font-display text-xl text-campaign-ink">pre Ružomberok</span>
          </div>
          <p className="text-campaign-ink/80 max-w-xs">
            {candidate.fullName} — {candidate.role} mesta {candidate.city}.
          </p>
          <div className="flex gap-3 mt-5">
            {social.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-11 h-11 bg-campaign-blue text-campaign-cream border-2 border-campaign-ink flex items-center justify-center hover:bg-campaign-coral transition-colors"
                >
                  <Icon size={20} />
                </a>
              );
            })}
          </div>
        </div>

        <div>
          <h4 className="font-display uppercase text-lg text-campaign-ink mb-4">Navigácia</h4>
          <ul className="space-y-2">
            {nav.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="font-semibold text-campaign-ink/80 hover:text-campaign-blue transition-colors">
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase text-lg text-campaign-ink mb-4">Kontakt</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-3 text-campaign-ink/80 font-semibold">
              <Mail size={18} className="text-campaign-coral" /> {contactInfo.email}
            </li>
            <li className="flex items-center gap-3 text-campaign-ink/80 font-semibold">
              <Phone size={18} className="text-campaign-coral" /> {contactInfo.phone}
            </li>
            <li className="flex items-center gap-3 text-campaign-ink/80 font-semibold">
              <MapPin size={18} className="text-campaign-coral" /> {contactInfo.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t-2 border-campaign-ink/20 flex flex-col items-center gap-3 text-center">
        <VisitCounter />
        <p className="text-campaign-ink/60 text-sm font-semibold">
          © 2026 Ján Kuráň. Všetky práva vyhradené. | Objednávateľ: Ján Kuráň, Ružomberok | Dodávateľ: Ján Kuráň, Ružomberok
        </p>
        <p className="text-campaign-ink/50 text-xs">Volebná kampaň · Ružomberok 2026</p>
      </div>
    </footer>
  );
};

export default Footer;
